/**
 * Gates the "Add Free BarTender 30-Day Trial" button: only enabled once a qualifying Zebra
 * printer is in the cart (the Bxgy discount's buy side). Initial state is server-rendered from
 * Liquid `cart`; thereafter it re-checks `/cart.js` on every cartUpdate, since the pub/sub
 * payload alone can't be trusted to reflect the whole cart.
 */
if (!customElements.get('printer-software-promo')) {
	customElements.define(
		'printer-software-promo',
		class PrinterSoftwarePromo extends HTMLElement {
			connectedCallback() {
				this.button = this.querySelector('button[name="add"]')
				this.hint = this.querySelector('.printer-software-promo__hint')
				if (!this.button) return
				this.setEnabled(this.dataset.initialEnabled === 'true')
				this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh())
			}

			disconnectedCallback() {
				if (this.unsubscribe) this.unsubscribe()
			}

			refresh() {
				const base = (window.routes && window.routes.cart_url) || '/cart'
				fetch(`${base}.js`, { headers: { Accept: 'application/json' } })
					.then(response => response.json())
					.then(cart => {
						const hasPrinter = (cart.items || []).some(
							item => item.vendor === 'Zebra' && /printer/i.test(item.product_type || ''),
						)
						this.setEnabled(hasPrinter)
					})
					.catch(() => {})
			}

			setEnabled(enabled) {
				this.button.disabled = !enabled
				this.button.setAttribute('aria-disabled', String(!enabled))
				if (this.hint) this.hint.toggleAttribute('hidden', enabled)
			}
		},
	)
}
